exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.root {\r\n    margin-bottom: 0;\n}\r\n", ""]);

